import React from 'react';
import clsx from 'clsx'

import { AppIconProps } from './AppIconProps'

import './AppIconStyles.scss'


/**
 * ATOM – Komponent ikony SVG, Obsługuje aria-label i aria-hidden
 * 
 * @param {SVGSVGElement} icon - Komponent ikony SVG zaimportowany. Ważne - musi to być komponent SVG, a nie ścieżka do pliku SVG.
 * @param {String} label - Opis alternatywny dla dostępności (aria-label)
 * @param {Boolean} decorative  - Czy ikona jest dekoracyjna - brak semantycznego znaczenia dla UI (aria-hidden)
 * @param {String} className - Dodatkowa klasa pozwalająca dodać customowe właściwości
*/
const AppIcon = (props: AppIconProps) => {
   const { icon: SvgIcon, label, decorative = false, width, height, color, className, onClick } = props
   const ariaProps = decorative? { "aria-hidden": true } : { role: "img", "aria-label": label}

   return (
      <SvgIcon
         className={clsx("app-icon", className)}
         focusable="false"
         onClick={(e) => onClick && onClick(e)}
         color={color ?? 'currentColor'} // Jeśli kolor nie został podany w propsach, używamy css'owego `currentColor` - wtedy komponent dziedziczy kolor od rodzica
         {...(width ? { width } : {})} // Jeśli podamy width, props zostanie ustawiony, w przeciwnym razie brane są domyślne wartości z ikonki
         {...(height ? { height } : {})} // Jeśli podamy height, props zostanie ustawiony, w przeciwnym razie brane są domyślne wartości z ikonki
         {...ariaProps}
      />
   )
}

export default AppIcon